import React, { useContext, useEffect, useState, useRef } from 'react'
import ProductAccessories from './ProductAccessories'
import { SiteContext } from '../../Global/SiteContext'
import { useDigifiSearchCore } from '../../DigifiSearch/Hooks/Core/useDigifiSearchCore'

const ProductRelatedProducts = () => {
   const { productInformation } = useContext(SiteContext)
   const { accessories } = productInformation ?? {}
   const { getProductsByItemNos } = useDigifiSearchCore()
   const [associatedProducts, setAssociatedProducts] = useState([])
   const isMountedRef = useRef(true)

   useEffect(() => {
      if (!Array.isArray(accessories) || accessories.length === 0) {
         setAssociatedProducts([])
         return
      }

      isMountedRef.current = true

      ;(async () => {
         if (!isMountedRef.current) return

         const productData = await getProductsByItemNos({
            itemNos: accessories,
            pageSize: 48,
         })

         if (isMountedRef.current) {
            setAssociatedProducts(productData || [])
         }
      })()

      return () => {
         isMountedRef.current = false // Marks component as unmounted to prevent state updates from ongoing API calls
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [accessories])

   return <ProductAccessories accessories={associatedProducts} />
}

export default ProductRelatedProducts
